import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import config from "./config";
// plugins
import cognito from "./plugins/aws/cognito";
import axiosPlugin from "./plugins/axios";
import bootstrapvue from "@/plugins/bootstrap-vue";
import "@/plugins/bootstrap-vue/css";

const app = createApp(App);

app.use(router);
app.use(cognito);
app.use(axiosPlugin);
app.use(store);
app.use(bootstrapvue);

app.mount("#app");

app.config.globalProperties.$cognito = cognito;
app.config.globalProperties.$cognito.configure(config);

console.log(`mode: `, process.env.VUE_APP_MODE);
console.log(`ver: `, process.env.VUE_APP_VER);
